import { TranslationMessages } from '../types';
import { app } from './app/en';
import { settingsApp } from './app/en';

const en: TranslationMessages = {
  nav: {
    howItWorks: 'How it works',
    why: 'Why?',
    features: 'Features',
    getStarted: 'GET STARTED',
    dashboard: 'Dashboard',
    blog: 'Blog',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Get Paid Easily',
    subtitle: 'Create payment links instantly, manage your balance, and withdraw to TON. 3% platform fee.',
    cta: 'Get Started',
    hairsim: 'Simulate your hair transplant',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Payment link created.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Monthly subscription',
    stars: 'Stars',
    payBtn: 'Pay 100 Stars',
    iPayNow: 'I pay now',
    paymentLabel: 'Telegram Stars payment',
    merchant: 'Merchant',
    amount: 'Amount',
    confirmPay: 'Confirm payment',
    paymentReceived: 'Payment received — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · credited to balance',
    thanks: 'Thanks, access activated',
    messagePlaceholder: 'Message',
  },
  stats: {
    title: 'Trusted by Thousands of Agents',
    subtitle: 'Join a growing community of merchants using Telegram Stars payments',
    activeAgents: 'Active Agents',
    transactions: 'Transactions',
    uptime: 'Uptime',
    support: 'Support',
  },
  features: {
    title: 'Everything You Need to Accept Telegram Stars Payments',
    subtitle: 'A complete platform to manage your Telegram Stars payments',
    instantTitle: 'Instant Creation',
    instantDesc: 'Become an agent in seconds. No configuration required.',
    balanceTitle: 'Balance Management',
    balanceDesc: 'Track your revenue in real-time with an intuitive dashboard.',
    paymentsTitle: 'Telegram Stars Payments',
    paymentsDesc: 'Accept payments in Telegram Stars via your bot.',
    securityTitle: 'Maximum Security',
    securityDesc: 'Immutable ledger, secure and transparent transactions.',
    withdrawTitle: 'TON Withdrawals',
    withdrawDesc: 'Withdraw your funds directly to your TON address.',
    apiTitle: 'Robust API',
    apiDesc: 'Easy integration with webhooks and a complete REST API.',
  },
  how: {
    title: 'How It Works',
    subtitle: 'Get started in 3 simple steps',
    startDemo: 'Start demo',
    demoRunning: 'Demo running...',
    reset: 'Reset',
    step1Title: '1. Sign Up',
    email: 'Email',
    password: 'Password',
    noCard: '✓ No credit card required',
    step2Title: '2. Create Payment Links',
    amountStars: 'Amount (Stars)',
    generatedLink: 'Generated link:',
    shareLink: '✓ Share this link with your customers',
    step3Title: '3. Withdraw Your Funds',
    tonAddress: 'TON Address',
    availableBalance: 'Available balance:',
    fee: 'Fee: 3%',
  },
  pricing: {
    title: 'Simple and Transparent Pricing',
    subtitle: 'No hidden fees, no commitment',
    commission: 'Commission',
    perTransaction: 'per transaction',
    freeAccount: 'Free account creation',
    noMonthly: 'No monthly fees',
    tonWithdrawals: 'Integrated TON withdrawals',
    completeDashboard: 'Complete dashboard',
    support247: '24/7 support',
    startNow: 'Start now',
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Everything you need to know about Telegram Stars payments',
    q1: 'How does Telegram Stars payment work?',
    a1: 'Telegram Stars payment allows merchants to accept payments directly through Telegram. Users create payment links, share them with customers, and receive payments in Telegram Stars currency.',
    q2: 'What is the platform fee?',
    a2: 'The platform fee is 3% per transaction. This covers payment processing, ledger management, and platform maintenance. There are no setup fees or monthly costs.',
    q3: 'How do I withdraw my Telegram Stars?',
    a3: 'You can request withdrawals to your TON wallet. Withdrawals are processed manually for security. Minimum withdrawal is 100 Stars.',
    q4: 'Is Telegram Stars payment secure?',
    a4: "Yes, all payments are processed through Telegram's secure payment system. We use industry-standard encryption and security practices.",
    q5: 'What are Telegram Stars?',
    a5: 'Telegram Stars is a virtual currency used within Telegram for payments. Users can purchase Stars and use them to pay for services, products, and subscriptions.',
    q6: 'Can I use Telegram Stars payments for my business?',
    a6: 'Yes! Telegram Stars Payment Platform is designed for merchants, creators, and businesses. You can accept payments for digital products, services, subscriptions, and more.',
  },
  cta: {
    title: 'Ready to Get Started?',
    subtitle: 'Join thousands of agents already using our platform',
    createAccount: 'Create free account',
    signIn: 'Sign in',
  },
  footer: {
    description: 'Complete SaaS platform for Telegram Stars payments',
    product: 'Product',
    features: 'Features',
    pricing: 'Pricing',
    support: 'Support',
    signIn: 'Sign in',
    docs: 'Documentation',
    copyright: '© 2024 Telegram Stars Payment Platform. All rights reserved.',
  },
  seo: {
    title: 'Telegram Stars Payment | Pay & Get Paid with Telegram Stars',
    description:
      'Telegram Stars payment platform: pay with Telegram Stars or get a Stars payment link in minutes. Ledger, redirects, withdraw to TON. Flat 3% fee. No monthly cost.',
    keywords:
      'telegram stars payment, pay with telegram stars, stars payment, stars payment telegram, telegram star payment, telegram stars payments, telegram stars pay, starspayment, telegramstars, telegram stars, accept telegram stars, telegram stars payment platform',
  },
  whyPage: {
    seoTitle: 'Why Choose Telegram Stars Payment Platform | Benefits & Advantages',
    seoDescription: 'Discover why merchants and creators choose Telegram Stars Payment Platform: instant setup, transparent pricing, secure payments, and global reach.',
    title: 'Why choose us?',
    subtitle: 'Built for merchants and creators who want simple Telegram Stars payments',
    r1Title: 'Instant Setup',
    r1Desc: 'Get started in seconds. No complex configuration or technical knowledge required.',
    r2Title: 'Transparent Pricing',
    r2Desc: 'Only 3% per transaction. No hidden fees, no monthly costs, no setup fees.',
    r3Title: 'Secure & Reliable',
    r3Desc: "Built on Telegram's secure payment infrastructure with industry-standard encryption.",
    r4Title: 'Global Reach',
    r4Desc: 'Accept payments from Telegram users worldwide. No geographical restrictions.',
    r5Title: 'Easy Integration',
    r5Desc: 'Simple API and webhooks. Integrate with your existing systems in minutes.',
    r6Title: 'TON Withdrawals',
    r6Desc: 'Withdraw directly to your TON wallet. Fast and secure withdrawals.',
  },
  howPage: {
    seoTitle: 'How It Works | Telegram Stars Payment Platform',
    seoDescription: 'Learn how to accept payments via Telegram Stars in 3 simple steps. Create your account, generate payment links, and withdraw to TON.',
    title: 'How it works',
    subtitle: 'Accept Telegram Stars payments in three simple steps',
  },
  settings: {
    title: "Settings",
    languageSection: "Language",
    defaultLanguage: "Default language",
    languageHint: "This language applies to the whole platform (landing pages and interface).",
    languageSaved: "Language updated",
    ...settingsApp,
  },
  app,
};

export default en;
